import { findKey } from "lodash";
import { isClient } from "common/helper";
import { cleanEnv, str } from "envalid";

export const envConfig = cleanEnv(process.env, {
  REACT_APP_ENV: str(),
  REACT_APP_VERSION: str({ default: "0.0.0.0" }),
  REACT_APP_DEFAULT_LANG: str({ default: "th" }),
  NODE_ENV: str({ default: "development" }),
});

const config = {
  production: {
    HOST: "https://flex-backoffice.dentsujoy.com",
    API_ENDPOINT: "https://flex-api.dentsujoy.com/graphql",
    API: "https://flex-api.dentsujoy.com",
    BACKOFFICE_ENDPOINT: "https://flex-backoffice.dentsujoy.com",
    APP_ENDPOINT: "https://flex.dentsujoy.com",
    MARKETPLACE_ENDPOINT: "https://marketplace-api.dentsujoy.com",
  },
  uat: {
    HOST: "https://flex-backoffice.dentsu-uat.zennite.co",
    API_ENDPOINT: "https://flex-api.dentsu-uat.zennite.co/graphql",
    API: "https://flex-api.dentsu-uat.zennite.co",
    BACKOFFICE_ENDPOINT: "https://flex-backoffice.dentsu-uat.zennite.co",
    APP_ENDPOINT: "https://flex.dentsu-uat.zennite.co",
    MARKETPLACE_ENDPOINT: "https://marketplace-api.dentsu-uat.zennite.co",
  },
  staging: {
    HOST: "https://flex-backoffice.dentsu-uat.zennite.co",
    API_ENDPOINT: "https://flex-api.dentsu-uat.zennite.co/graphql",
    API: "https://flex-api.dentsu-uat.zennite.co",
    BACKOFFICE_ENDPOINT: "https://flex-backoffice.dentsu-uat.zennite.co",
    APP_ENDPOINT: "https://flex.dentsu-uat.zennite.co",
    MARKETPLACE_ENDPOINT: "https://marketplace.api.uat.zennite.co",
  },
  development: {
    HOST: "https://flex-backoffice.colima.localhost",
    API_ENDPOINT: "https://flex-api.colima.localhost/graphql",
    API: "https://flex-api.colima.localhost",
    BACKOFFICE_ENDPOINT: "https://flex-backoffice.colima.localhost",
    APP_ENDPOINT: "https://flex.colima.localhost",
    MARKETPLACE_ENDPOINT: "https://marketplace.api.uat.zennite.co",
  },
};

export const getEnvByHost = () =>
  isClient ? findKey(config, { HOST: window.location.origin }) : null;

export const nodeEnv = getEnvByHost() || "development";

console.log("HOST : ", getEnvByHost());

const appEnvConfig = {
  production: {
    HOST: "https://flex.dentsujoy.com",
    API_ENDPOINT: "https://flex-api.dentsujoy.com/graphql",
    API: "https://flex-api.dentsujoy.com",
  },
  uat: {
    HOST: "https://flex.dentsu-uat.zennite.co",
    API_ENDPOINT: "https://flex-api.dentsu-uat.zennite.co/graphql",
    API: "https://flex-api.dentsu-uat.zennite.co",
  },
  staging: {
    HOST: "https://flex.dentsu-uat.zennite.co",
    API_ENDPOINT: "https://flex-api.dentsu-uat.zennite.co/graphql",
    API: "https://flex-api.dentsu-uat.zennite.co",
  },
  e2eStaging: {
    HOST: "https://flex.dentsu-uat.zennite.co",
    API_ENDPOINT: "https://flex-api.dentsu-uat.zennite.co/graphql",
    API: "https://flex-api.dentsu-uat.zennite.co",
  },
  development: {
    HOST: "https://flex.colima.localhost",
    API_ENDPOINT: "https://flex-api.colima.localhost/graphql",
    API: "https://flex-api.colima.localhost",
  },
};

const MOCK_MSAL_CONFIG = {
  production: {
    REACT_APP_MSAL_CLIENT_ID: "aa3d3245-7975-475f-a0d2-f4728d3f9294",
    REACT_APP_MSAL_AUTHORITY: "https://login.microsoftonline.com/common",
    REACT_APP_MSAL_REDIRECT_URI: "https://flex.dentsujoy.com",
    REACT_APP_MSAL_LOGOUT_REDIRECT_URI: "https://flex.dentsujoy.com",
  },
  uat: {
    REACT_APP_MSAL_CLIENT_ID: "aa3d3245-7975-475f-a0d2-f4728d3f9294",
    REACT_APP_MSAL_AUTHORITY: "https://login.microsoftonline.com/common",
    REACT_APP_MSAL_REDIRECT_URI: "https://flex.dentsu-uat.zennite.co",
    REACT_APP_MSAL_LOGOUT_REDIRECT_URI: "https://flex.dentsu-uat.zennite.co",
  },
  staging: {
    REACT_APP_MSAL_CLIENT_ID: "96283f69-2148-4bf1-a97a-4478c83a8e41",
    REACT_APP_MSAL_AUTHORITY: "https://login.microsoftonline.com/common",
    REACT_APP_MSAL_REDIRECT_URI: "https://dev.backoffice.my-benefit.ldrive.io",
    REACT_APP_MSAL_LOGOUT_REDIRECT_URI:
      "https://dev.backoffice.my-benefit.ldrive.io",
  },
  development: {
    REACT_APP_MSAL_CLIENT_ID: "96283f69-2148-4bf1-a97a-4478c83a8e41",
    REACT_APP_MSAL_AUTHORITY: "https://login.microsoftonline.com/common",
    REACT_APP_MSAL_REDIRECT_URI: "http://localhost:21702",
    REACT_APP_MSAL_LOGOUT_REDIRECT_URI: "http://localhost:21702",
  },
};

export const appEnv = appEnvConfig[nodeEnv];

const env = {
  ...config[nodeEnv],
  ...MOCK_MSAL_CONFIG[nodeEnv],
};

console.log("ENV : ", env);
export default env;
